import React from "react";
import Button from "react-bootstrap/Button";
import { useHistory } from "react-router-dom";
import { USER_POOL_SETTINGS } from "../config/userPools";
import { useAuthenticator, Authenticator } from "@aws-amplify/ui-react";
import { Amplify, Auth, I18n } from "aws-amplify";
import { Loader } from "./Loader";
import logoDark from "../assets/logoDark.png";
import ChangeLanguage from "./ChangeLanguage";
import { amplifyAuthVocabularies } from "../config/amplifyAuthI18n";

//import { Amplify } from "aws-amplify";

// import { createProfile } from "@/hooks/useApi/students";
// import { useLang } from "@/context/lang";

// const Authenticator = dynamic(() => import("./Authenticator"), { ssr: false });

I18n.putVocabularies(amplifyAuthVocabularies);

export interface IProtectedProps {
  /** Keys for user pool destination. By default it is common "studentspeak" user pool */
  awsUserPoolConfig?: typeof USER_POOL_SETTINGS;
  /** predefined GUID of user which is generated on assessment start. Needed to connect assesment with later student instance. */
  referenceId?: string | null;
}

export default function Protected({
  awsUserPoolConfig = USER_POOL_SETTINGS,
  referenceId,
  children,
}: React.PropsWithChildren<IProtectedProps>) {
  // React.useLayoutEffect(() => {
  //TODO: use it as effect
  Amplify.configure(awsUserPoolConfig);

  // }, []);

  const history = useHistory();
  const { user, authStatus } = useAuthenticator();
  const prevAuthStatus = React.useRef(authStatus);

  React.useEffect(() => {
    if (
      prevAuthStatus.current !== "authenticated" &&
      authStatus === "authenticated"
    ) {
      history.replace("/");
    }
    prevAuthStatus.current = authStatus;
  }, [authStatus, history]);

  console.log(user);

  // const handleSignUp = async (formData: any) => {
  //   // custom login process
  //   const signUpResult = await Auth.signUp({
  //     ...formData,
  //     autoSignIn: {
  //       enabled: true,
  //     },
  //   });

  //   if (signUpResult.userSub) {
  //     await createProfile({
  //       latestAssessmentReferenceId: referenceId || null,
  //       userExternalId: signUpResult.userSub,
  //       universityAcronym: getUserPoolById(awsUserPoolConfig.Auth.userPoolId),
  //       email: formData.username,
  //     });
  //   }

  //   return signUpResult;
  // };

  const handleSignIn = async (formData: any) => {
    return Auth.signIn(formData);
  };

  const formFields = {
    setupTOTP: {
      QR: {
        totpIssuer: "Studentspeak",
        totpUsername: "admin",
      },
    },
  };

  return authStatus == "authenticated" ? (
    <Loader loading={!Boolean(user)}>{children}</Loader>
  ) : (
    <LoginWrapper>
      <>
        {/* <button
          onClick={() => Auth.federatedSignIn({ provider: "Passage" as any })}
        >
          sign in federated
        </button> */}
        <Authenticator
          formFields={formFields}
          services={{
            // handleSignUp,
            handleSignIn,
          }}
          components={{
            SignIn: {
              Header: () => <></>,
              Footer: () => <></>,
            },
          }}
        />
      </>
    </LoginWrapper>
  );
}

const LoginWrapper = ({ children }: React.PropsWithChildren) => {
  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="login-logo">
          <img width="200" src={logoDark} alt="Studentspeak" />
        </div>
        <div className="login-body">
          {children}
          <div className="form-language-button">
            <ChangeLanguage
              light
              compact
              showLangNames
              onChange={() => {
                window.location.reload(); //to apply I18n settings in lang context
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
